import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/

    createProduct(data){
        let params = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/creatProduct",data, method: 'POST', ...options});
    },
    modifyProduct(data){
        let params = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/modifyProduct",data, method: 'POST', ...options});
    },

    productDetail(productId){
        let params = {
            productId:productId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productDetail",data, method: 'GET', ...options});
    },
    productRecommend(productId){
        let params = {
            productId:productId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productRecommend",data, method: 'GET', ...options});
    },
    getProductBrandInfo(productId){
        let params = {
            productId:productId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productBrandInfo",data, method: 'GET', ...options});
    },

    bookProductPresell(productId, form){
        let params = {

        }
        let data = {
            productId:productId,
            remark:form.remark,
            sales:form.sales,
            platform: form.platform,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/bookProduct",data, method: 'POST', ...options});
    },






    getNewSkuSn(catId, num){
        let params = {
            catId: catId,
            num:num
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/getNewSkuSn",data, method: 'GET', ...options});
    },
    checkSupplierSkuSn(productId, shopSkuSn){
        let params = {
            productId: productId,
            shopSkuSn:shopSkuSn
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/checkSupplierSkuSn",data, method: 'GET', ...options});
    },

    downloadAnnex(productId, uniKey, code, annexIndexes, certIndexes){
        let params = {

        }
        let data = {
            productId: productId,
            uniKey:uniKey,
            code:code,
            annexIndexes:annexIndexes,
            certIndexes:certIndexes,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/downloadAnnex",data, method: 'POST', ...options});
    },
    annexBaiduShare(productId, uniKey, code){
        let params = {

        }
        let data = {
            productId: productId,
            uniKey:uniKey,
            code:code,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/annexBaiduShare",data, method: 'POST', ...options});
    },


    productBrands(){
        let params = {
        }
        params.platform = 2; //食品站2
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productBrands",data, method: 'GET', ...options});
    },
    productCatParams(catId){
        let params = {
            catId:catId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productCatParams",data, method: 'GET', ...options});
    },
    productCatCerts(catId){
        let params = {
            catId:catId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productCatCerts",data, method: 'GET', ...options});
    },

    productCats(catId){
        let params = {
            catId: catId,
        }
        params.platform = 2; //食品站2
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productCats",data, method: 'GET', ...options});
    },

    productCatInfo(catId){
        let params = {
            catId: catId,
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/product/productCatInfo",data, method: 'GET', ...options});
    },

    filterProductSku(filter){
        let params = filter
        params.type = 2; //默认普货站
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/home/product/filterProduct",data, method: 'GET', ...options});
    },


    homeNoLoginProduct(filter){
        let params = filter
        params.type = 2; //默认普货站
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/home/product/homeProduct",data, method: 'GET', ...options});
    },

    homeFoodSuggestProduct(){
        let params = {}
        params.type = 2; //默认普货站
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/home/product/homeSuggestProduct",data, method: 'GET', ...options});
    },







    /***************************************************** end *********************************************/
}
